import { useEffect, useState } from "react";

const Clock = () => {
  const [date, setDate] = useState(new Date());
  useEffect(() => {
    setInterval(() => setDate(new Date()), 1000);
  }, []);

  return (<span>{date.toLocaleTimeString('en-GB') }</span>);
};

export default Clock;